



















import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import FormItem from '@/components/Money/FormItem.vue';
import Button from '@/components/Button.vue';

@Component({
  components: {Button, FormItem}
})
export default class EditLabel extends Vue {

  get currentTag() {
    return this.$store.state.currentTag;
  }

  created() {
    const id = this.$route.params.id;
    this.$store.commit('setCurrentTag', id);
    console.log('currentTag');
    console.log(this.currentTag);
    if (!this.currentTag) {
      this.$router.replace('/404');
    }
  }

  goBack() {
    this.$router.back();
  }

  update(name: string) {
    this.$store.commit('updateTag', {id: this.currentTag.id, name: name});
    // oldStore.updateTag(this.currentTag.id, name);
  }

  remove() {
    this.$store.commit('removeTag', this.currentTag.id);
  }
}

